import { useEffect, useState } from 'react';
import { fetchEVNHistory } from '../services/evn.api'; 
import { getAssignmentStatus, safeTrim } from '../utils/evn.helpers';

export function deriveEVNStatus(from, to) {
  return getAssignmentStatus(from, to);
}

export function useEVNVersions(evnId) {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!evnId) return;
    let alive = true;
    const ac = new AbortController();

    (async () => {
      try {
        setLoading(true);
        const raw = await fetchEVNHistory(evnId, ac.signal);
        const mapped = Array.isArray(raw)
          ? raw.map((r) => ({
              meterStatus: getAssignmentStatus(r.FromDate, r.ToDate),
              MeterNumber: r.MeterNumber ?? null,
              MeterType: r.MeterType ?? null,
              FromDate: r.FromDate ?? null,
              ToDate: r.ToDate ?? null,
              Comments: safeTrim(r.Comments) ?? null,
              Faulty: r.Faulty ?? null,
              AssignmentRecordedOn: r.AssignmentRecordedOn ?? null,
            }))
          : [];
        if (!alive) return;
        setVersions(mapped);
      } catch (e) {
        console.error('useEVNVersions:', e);
        if (alive) setVersions([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
      ac.abort();
    };
  }, [evnId]);

  return { versions, loading };
}
